import { ErrorHandler } from '@angular/core';

import { environment } from '../environments/environment';

import rg4js from 'raygun4js';

const VERSION_NUMBER = environment.VERSION;
const API_KEY = environment.raygun.apiKey;

const CRASH_REPORTING_ENABLED = true;

rg4js('apiKey', API_KEY);
rg4js('setVersion', VERSION_NUMBER);
rg4js('enableCrashReporting', CRASH_REPORTING_ENABLED);
rg4js('options', {
  // https://raygun.com/documentation/language-guides/javascript/crash-reporting/script-errors/#browser-extension-errors
  ignore3rdPartyErrors: true,
});
rg4js('onBeforeSend', payload => {
  // TODO: This errors are ignored to decrease raygun budget and because the error is related to backend. Should be
  // solved in the backend side.
  const error = payload.Details.Error;
  if (
    error &&
    error.Message &&
    (error.Message.includes(
      'Http failure response for https://bff-backend.einsatzwetter.de/youtube/news: 400 OK'
    ) ||
      error.Message.includes(
        'Http failure response for https://bff-backend.einsatzwetter.de/youtube/tutorial: 400 OK'
      ) ||
      error.Message.includes(
        'Http failure response for https://bff-backend.einsatzwetter.de/youtube/pigeon: 400 OK'
      ))
  ) {
    return false;
  }
  return payload;
});
// Pulse (Real User Monitoring/Benutzertracking) ist ein separater Kanal von
// der Crash-/Fehlerberichterstattung oben, schickt aber genauso Requests an
// Raygun (POST .../events).
rg4js('enablePulse', CRASH_REPORTING_ENABLED);

export class RaygunErrorHandler implements ErrorHandler {
  handleError(e: any): void {
    // enableCrashReporting steuert nur raygun4js' eigene automatische
    // window.onerror-Erfassung, nicht diesen expliziten send()-Aufruf –
    // deshalb hier zusätzlich absichern.
    if (!CRASH_REPORTING_ENABLED) {
      console.error(e);
      return;
    }
    rg4js('send', {
      error: e,
    });
  }
}
